import React, { useEffect, useState } from 'react';
import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import './NewOperationProduct.css';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import ComboBox from 'Components/ComboBox/ComboBox';
import PanelListDefaultGridEditable from 'Components/PanelListGridEditable/PanelListDefaultGridEditable';
import { getFromLocalStorage, saveToLocalStorage, clearLocalStorage } from 'Components/AutomaticallyListedAttributesGrid/AutomaticallyListedAttributesGrid';
import InputField from 'Components/Input/InputField';
import Button from 'Components/Button/Button';

const NewOperationProduct = ({
    onUpdateShowNewOperationProduct,
    onUpdateShowNewOperationSupplier,
    onUpdateOperationsProduct,
    productIdSelected,
    showNewOperationProduct,
    showNewOperationSupplier
}) => {
    const [loadingNewOperationPanel, setLoadingNewOperationPanel] = useState(false);
    const [classificationIdSelected, setClassificationIdSelected] = useState(null);
    const [classificationList, setClassificationList] = useState([]);
    const [machineList, setMachineList] = useState([]);
    const [operationList, setOperationList] = useState(null)
    const [dsOperation, setDsOperation] = useState(null);
    const [sequenceCount, setSequenceCount] = useState(1);
    const [fullOperationList, setFullOperationList] = useState([]);

    const callToSetMachineList = async () => {
        try {
            const machineList = await ExecuteAxios.api('get', `/machine/get-active-machine-list/`);
            setMachineList(machineList);
        } catch (error) {
            console.error('Failed to fetch machine list:', error);
        }
    };

    const callToSetClassificationList = async () => {
        try {
            const classificationList = await ExecuteAxios.api('get', `/classification/get-active-classification-list/`);
            setClassificationList(classificationList);
        } catch (error) {
            console.error('Failed to fetch classification list:', error);
        }
    };

    const itemsMachineOptions = OptionsDataByAttributePath(machineList, ['description'], null, true);
    const itemsClassificationOptions = OptionsDataByAttributePath(classificationList, ['description'], null, true);

    useEffect(() => {
        const onReady = async () => {
            await callToSetMachineList();
            await callToSetClassificationList();
            clearLocalStorage('operationList');
        };
        onReady();
    }, []);

    useEffect(() => {
        const onReady = async () => {
            setSequenceCount(1)
            clearLocalStorage('operationList')
        };
        onReady();
    }, [showNewOperationProduct]);

    useEffect(() => {
        if (productIdSelected || classificationIdSelected) {
            clearLocalStorage('operationList')
            reloadListProductOperation()
        }
    }, [productIdSelected, classificationIdSelected, showNewOperationSupplier]);

    useEffect(() => {
        if (!dsOperation || dsOperation.trim() === '') {
            setOperationList(fullOperationList);
        } else {
            const filtered = fullOperationList.filter(op => {
                const labelAttr = op.constructorList.find(attr => attr.field === 'dsOperation');
                return labelAttr?.argument?.toLowerCase().includes(dsOperation.toLowerCase());
            });
            setOperationList(filtered);
        }
    }, [dsOperation]);


    const attributeList = [
        {
            name: 'id',
            style: { height: '100%' },
            attributesChange: [
                {
                    condition: [
                        {
                            name: 'id',
                            value: 'S'
                        }
                    ],
                    name: 'operationSequence',
                    getterNewValue: sequenceCount,
                    setterAfterGetter: () => { setSequenceCount(sequenceCount === 1 ? sequenceCount + 4 : sequenceCount + 5) },
                },
                {
                    condition: [
                        {
                            name: 'id',
                            value: 'N'
                        }
                    ],
                    name: 'operationSequence',
                    getterNewValue: ' ',
                    setterAfterGetter: () => { },
                }
            ]
        },
        {
            name: 'dsOperation', width: '400px',
            style: {
                height: '100%',
                border: 'none',
                outline: 'none',
                resize: 'none',
                whiteSpace: 'normal',
                fontFamily: 'SFProDisplay-Regular, Helvetica, Arial, sans-serif',
                color: 'black'
            }
            , cursor: 'text',
            minGridWidth: '400px',
            maxGridWidth: '400px'
        },
        {
            name: 'machineId', comboboxOptions: itemsMachineOptions,
            style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            }
        },
        {
            name: 'operationSequence', width: '100px',
            style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            }
        },
        {
            name: 'timePerOperation',
            style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            },
            decimalScale: 4,
            mask: 'operationTime'
        },
        {
            name: 'isExternal',
            style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            },
        },
        {
            name: 'operationTimer',
            style: {
                border: 'none',
                outline: 'none',
                resize: 'none',
            },
            minGridWidth: '130px',
            maxGridWidth: '130px',
            copyValueToFields: ['timePerOperation']
        }
    ];

    function resetSequenceCount() {
        if (!haveCheckBoxFlaged()) {
            setSequenceCount(1)
        }
    }

    function haveCheckBoxFlaged() {
        const rowsBackend = getFromLocalStorage('operationList');
        return rowsBackend.some(row =>
            row.constructorList.some(attribute =>
                attribute.field.toUpperCase() === 'ID' && attribute.checked === 'S'
            )
        );
    }

    const reloadListProductOperation = async () => {
        if (productIdSelected && productIdSelected.length === 1) {
            await getOperationRecords(productIdSelected[0]);
        }
    };

    const getOperationRecords = async (productIdSelected) => {
        const parameters = {
            productId: productIdSelected,
            classificationId: classificationIdSelected,
            dsOperation: null
        };
        const operations = await ExecuteAxios.api('get', `/product-operation/get-operations-list-to-product/`, { params: parameters });
        if (operations) {
            saveToLocalStorage('operationList', setOperationList, setFullOperationList, operations,);
        }
    };

    const cancelFunction = () => {
        onUpdateShowNewOperationProduct(false);
        resetVariables();
    };

    const resetVariables = () => {
        setClassificationIdSelected(null);
    };

    const postFunction = async () => {
        try {
            setLoadingNewOperationPanel(true);
            const operationList = mappedOperations();
            const response = await ExecuteAxios.api('post', `/product-operation/`, operationList);

            if (response) {
                onUpdateOperationsProduct(true);
                resetVariables();
                onUpdateShowNewOperationProduct(false);
            }

            return response;
        } finally {
            setLoadingNewOperationPanel(false);
        }
    };

    function getNewOperationSupplier() {
        return (
            <Button
                clickMethod={() => { onUpdateShowNewOperationSupplier(true) }}
                buttonName={'Adicionar operação'}
                style={styleDuplicateButton}
                disabled={showNewOperationSupplier}
                readOnly={showNewOperationSupplier}
            />
        )
    }

    const styleDuplicateButton = {
        width: '150px',
        float: 'right',
        color: showNewOperationSupplier ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    const mappedOperations = () => {
        const operationList = getFromLocalStorage('operationList');
        return operationList.map(operation => {
            const operationId = operation.id;
            const machineId = operation.constructorList.find(item => item.field === 'machineId')?.argument;
            const timePerOperation = operation.constructorList.find(item => item.field === 'timePerOperation')?.argument;
            const operationSequence = operation.constructorList.find(item => item.field === 'operationSequence')?.argument;
            const isExternal = operation.constructorList.find(item => item.field === 'isExternal')?.checked;
            const productId = productIdSelected[0]
            const checked = operation.constructorList[0].checked;

            return {
                operationId,
                machineId,
                timePerOperation,
                operationSequence,
                checked,
                productId,
                isExternal
            };
        });
    };

    return (
        <MiddlePanel isVisible={showNewOperationProduct}>
            <LoadingIndicator loaded={!loadingNewOperationPanel}>
                <Panel
                    style={{
                        width: '1000px',
                        height: '600px',
                        borderRadius: '10px',
                        backgroundColor: '#f5f5f5;',
                        border: '1px solid #ccc',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.3)',
                        displey: 'flex',
                        flexDirection: 'column'
                    }}
                    titlePage={'Definir operações'}
                    canViewCRUD={true}
                    postFunction={postFunction}
                    insertNameButton='Adicionar'
                    cancelFunction={cancelFunction}
                    enableNewRecord={true}
                    canNewRecord={true}
                    enableDelete={true}
                    canDelete={true}
                    inserting={true}
                    componentLeftButtons={getNewOperationSupplier()}
                >
                    <Panel style={{ marginLeft: '10px', height: '12%', display: 'flex', flexDirection: 'row' }}>
                        <div style={{ margin: '5px', display: 'flex', flexDirection: 'column' }}>
                            <span className='span-operation-filter'>Classificação</span>
                            <ComboBox
                                setAttribute={setClassificationIdSelected}
                                optionsData={itemsClassificationOptions}
                                style={{ width: '250px', cursor: 'pointer' }}
                                value={classificationIdSelected}
                                defaultValue={classificationIdSelected}
                            />
                        </div>

                        <div style={{ margin: '5px', display: 'flex', flexDirection: 'column' }}>
                            <span className='span-operation-filter'>Operação</span>
                            <InputField
                                setAttribute={(event) => setDsOperation(event)}
                                value={dsOperation}
                                readOnly={false}
                                disabled={false}
                                style={{ cursor: 'pointer', width: '250px' }}
                            />
                        </div>
                    </Panel>
                    <PanelListDefaultGridEditable
                        rowsBackend={operationList}
                        setRowsBackend={setOperationList}
                        updateHelperOperationList={setFullOperationList}
                        localStorageName={'operationList'}
                        attributeList={attributeList}
                        height={'calc(88% - 65px)'}
                        executeAfterSave={resetSequenceCount}
                        dsOperation={dsOperation}
                    />
                </Panel>
            </LoadingIndicator>
        </MiddlePanel>
    );
};

export default NewOperationProduct;
